import { createRoute } from '@tanstack/react-router';
import { appRoute } from './parent-routes';
import PlaceholderPage from '@phrmpc/shared/components/PlaceholderPage';

const trainingContentRoute = createRoute({
  getParentRoute: () => appRoute,
  path: 'training-content',
  component: () => <PlaceholderPage title="Training Content & Online Forms" />,
  staticData: {
    handle: { title: 'Training Content' },
  },
});

export default trainingContentRoute;
